import { types } from '../../../types/types';

export const reducerToken = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.AUTHAPICIDTECH:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }
    return result;
}